var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-scrollable-content"},[_c('div',{ref:"scrollableItems",staticClass:"d-scrollable-items",attrs:{"id":`scrollable-items-${ _vm._uid }`}},[_vm._t("content")],2),_vm._v(" "),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('DuiScrollAvailable',{attrs:{"ref-element-id":`scrollable-items-${ _vm._uid }`}})
}]

export { render, staticRenderFns }